/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Items_Currently_AvailableInputs */

const en_no_items_currently_available = /** @type {(inputs: No_Items_Currently_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No items currently available.`)
};

const es_no_items_currently_available = /** @type {(inputs: No_Items_Currently_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay artículos disponibles en este momento.`)
};

const fr_no_items_currently_available = /** @type {(inputs: No_Items_Currently_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun article actuellement disponible.`)
};

const de_no_items_currently_available = /** @type {(inputs: No_Items_Currently_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurzeit keine Artikel verfügbar.`)
};

const ja_no_items_currently_available = /** @type {(inputs: No_Items_Currently_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在ご利用いただける商品はありません。`)
};

const zh_no_items_currently_available = /** @type {(inputs: No_Items_Currently_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前无可用商品。`)
};

const ar_no_items_currently_available = /** @type {(inputs: No_Items_Currently_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد عناصر متاحة حالياً.`)
};

const id_no_items_currently_available = /** @type {(inputs: No_Items_Currently_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada item yang tersedia saat ini.`)
};

const it_no_items_currently_available = /** @type {(inputs: No_Items_Currently_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun articolo attualmente disponibile.`)
};

const ru_no_items_currently_available = /** @type {(inputs: No_Items_Currently_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В настоящее время нет доступных товаров.`)
};

const pt_no_items_currently_available = /** @type {(inputs: No_Items_Currently_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum item disponível no momento.`)
};

const ko_no_items_currently_available = /** @type {(inputs: No_Items_Currently_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 사용 가능한 항목이 없습니다.`)
};

/**
* | output |
* | --- |
* | "No items currently available." |
*
* @param {No_Items_Currently_AvailableInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_items_currently_available = /** @type {((inputs?: No_Items_Currently_AvailableInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Items_Currently_AvailableInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_items_currently_available(inputs)
	if (locale === "es") return es_no_items_currently_available(inputs)
	if (locale === "fr") return fr_no_items_currently_available(inputs)
	if (locale === "de") return de_no_items_currently_available(inputs)
	if (locale === "ja") return ja_no_items_currently_available(inputs)
	if (locale === "zh") return zh_no_items_currently_available(inputs)
	if (locale === "ar") return ar_no_items_currently_available(inputs)
	if (locale === "id") return id_no_items_currently_available(inputs)
	if (locale === "it") return it_no_items_currently_available(inputs)
	if (locale === "ru") return ru_no_items_currently_available(inputs)
	if (locale === "pt") return pt_no_items_currently_available(inputs)
	return ko_no_items_currently_available(inputs)
});